// extracted by mini-css-extract-plugin
export default {"wrap":"a36ab0306f4c","footer":"be13b7cce38c","imageTextContainer":"eec08e5dc63e"};